import InstaTaskSideBarItem from './InstaTaskSideBarItem';

export default InstaTaskSideBarItem;
